var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19236_531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 4.33331C12.9999 3.78103 12.5522 3.33331 11.9999 3.33331C11.4476 3.33331 10.9999 3.78103 10.9999 4.33331V13.2524L8.70703 10.9595C8.3165 10.569 7.68334 10.569 7.29281 10.9595C6.90229 11.3501 6.90229 11.9832 7.29281 12.3738L11.2928 16.3738C11.6833 16.7643 12.3165 16.7643 12.707 16.3738L16.707 12.3738C17.0975 11.9832 17.0975 11.3501 16.707 10.9595C16.3165 10.569 15.6833 10.569 15.2928 10.9595L12.9999 13.2524L12.9999 4.33331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 17C20.6666 16.4477 20.2189 16 19.6666 16C19.1143 16 18.6666 16.4477 18.6666 17V18.0666C18.6666 18.6189 18.2189 19.0666 17.6666 19.0666L6.33325 19.0666C5.78097 19.0666 5.33325 18.6189 5.33325 18.0666L5.33325 17C5.33325 16.4477 4.88554 16 4.33325 16C3.78097 16 3.33325 16.4477 3.33325 17V18.0666C3.33325 19.7235 4.6764 21.0666 6.33325 21.0666L17.6666 21.0666C19.3234 21.0666 20.6666 19.7235 20.6666 18.0666V17Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19236_531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/iconDownload.fa04990d08d1a3f30c77ae2396fdbc30.svg";
export { ForwardRef as ReactComponent };